module.exports = __webpack_public_path__ + "media/images/samuel-ac947da061a03e034b9179e695889744.jpg";